export default __webpack_public_path__ + "static/media/panordic.bdb2b62e.png";